import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './LinkToVehicle.styles';
import {
  selectCarWithoutMapEffect,
  selectSelectedDrawersCount,
} from '../../redux/store/ui/common';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

interface Props {
  text?: string;
  carId: string;
  activeTab?: number;
  onClick?: () => void;
  icon?: string;
}

const LinkToVehicle: React.FC<Props> = ({
  text,
  carId,
  activeTab,
  onClick,
  icon,
}) => {
  const dispatch = useDispatch();
  const openedDrawersCount = useSelector(selectSelectedDrawersCount);

  const onClickHandler = (e: any) => {
    e.preventDefault();
    if (carId != null && openedDrawersCount < 2) {
      dispatch(selectCarWithoutMapEffect({ id: carId }, false, activeTab));
    }
  };

  return (
    <>
      {openedDrawersCount < 2 ? (
        <div className="link-wrapper" onClick={onClick || onClickHandler}>
          <div className="link-label">{text || ''}</div>
          {icon && <img className="icon" src={icon} alt="edit" />}
        </div>
      ) : (
        <Link
          replace={false}
          to={{
            pathname: '/dashboard',
            search: `?vm=VEHICLE&type=TABLE&pageSize=50&pageNumber=1&carId=${carId}${
              activeTab ? `&carTab=${activeTab}` : ''
            }`,
          }}
          target="_blank"
        >
          <a className="external-link-wrapper" target="_blank" rel="noreferrer">
            <span className="link-label">{text || ''}</span>
            <ExportOutlined
              color="#0077be"
              style={{ fontSize: '18px', marginLeft: '10px' }}
            />
          </a>
        </Link>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToVehicle;
